import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Content from '@/modules/common/components/Content';
import GridItem from '@/modules/common/components/GridItem';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import GridContainer from '@/modules/common/components/GridContainer';
import { withFetch } from '~/hocs/fetch';
import History from './History/History';
import Information from './Information/Information';
import '../../styles/Lead.scss';

let abortController1;
let abortController2;

const Lead = (props) => {
    const id = props.match.params.id;
    const breadcrumbs = [
        {name: 'Лиды', to: '/leads/'},
        {name: id},
    ];

    const [loadingLead, setLoadingLead] = useState(true);
    const [loadingHistory, setLoadingHistory] = useState(true);
    const [lead, setLead] = useState(null);
    const [history, setHistory] = useState(null);

    const fetchLead = () => {
        abortController1 = new AbortController();
        setLoadingLead(true);
        props.fetch.get(`/api/leads/${id}/`, abortController1)
            .then(({ok, data}) => {
                if (ok) {
                    setLead(data);
                }
                setLoadingLead(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoadingLead(false);
                }
            })
            .finally(() => {
                abortController1 = null;
            });
    };

    const fetchHistory = () => {
        if (!props.user.affiliate) {
            abortController2 = new AbortController();
            setLoadingHistory(true);
            props.fetch.get(`/api/leads/${id}/history/`, abortController2)
                .then(({ok, data}) => {
                    if (ok) {
                        setHistory(data);
                    }
                    setLoadingHistory(false);
                })
                .catch((error) => {
                    if (error.name !== 'AbortError') {
                        setLoadingHistory(false);
                    }
                })
                .finally(() => {
                    abortController2 = null;
                });
        }
    };

    useEffect(() => {
        fetchLead();
        fetchHistory();
        return () => {
            if (abortController1) {
                abortController1.abort();
            }
            if (abortController2) {
                abortController2.abort();
            }
        };
    }, []);

    return (
        <Content id="lead">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6} xl={6}>
                        <Information loading={loadingLead} lead={lead} fetch={fetchLead}/>
                    </GridItem>
                    {(!props.user.affiliate)
                        ? <GridItem xs={12}>
                            <History loading={loadingHistory} history={history} fetch={fetchHistory}/>
                        </GridItem>
                        : null
                    }
                </GridContainer>
            </ContentBody>
        </Content>
    );
};

let Component = Lead;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null
)(Component);
